import type { ReactNode } from 'react';

/*
 * Minimal line icons for the nav sections, keyed by NAV_SECTIONS.key. Kept local to the admin app
 * (not the design system): they are wayfinding glyphs for this console's sections, not reusable
 * primitives. Placeholder-simple until the real screens refine them.
 */

function Glyph({ d }: { d: string }): ReactNode {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d={d}
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const NAV_ICONS: Record<string, ReactNode> = {
  contests: (
    <Glyph d="M7 4h10v4a5 5 0 01-10 0V4zM7 4H4v1a3 3 0 003 3M17 4h3v1a3 3 0 01-3 3M9 21h6M12 17v4" />
  ),
  catalogue: <Glyph d="M4 6h16v12H4zM4 10h16" />,
  players: <Glyph d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20a8 8 0 0116 0" />,
  settlement: <Glyph d="M5 12l4 4L19 6" />,
  awards: <Glyph d="M12 15a5 5 0 100-10 5 5 0 000 10zM9 14l-2 6 5-3 5 3-2-6" />,
  configuration: (
    <Glyph d="M12 15a3 3 0 100-6 3 3 0 000 6zM19 12l2-1-1-3-2 .5-2-1.5-.5-2h-3l-.5 2-2 1.5-2-.5-1 3 2 1-2 1 1 3 2-.5 2 1.5.5 2h3l.5-2 2-1.5 2 .5 1-3z" />
  ),
  admins: <Glyph d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20a8 8 0 0113-6.3M18 16v6M15 19h6" />,
};
